import * as Tooltip from '@radix-ui/react-tooltip';
import { useContext, type FC, type ReactElement } from 'react';
import { SegmentPortalContext } from './segment-portal-context';
import styles from './SegmentVisualBuilder.module.css';

interface BuilderTooltipProps {
  label: string;
  /** Trigger element. Radix clones it, so it has to forward props to a focusable DOM node. */
  children: ReactElement;
}

/** Carries its own provider because Radix throws outright when a `Tooltip.Provider` ancestor is missing. */
export const BuilderTooltip: FC<BuilderTooltipProps> = ({ label, children }) => {
  const portalContainer = useContext(SegmentPortalContext);
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal container={portalContainer}>
          <Tooltip.Content className={styles.builderTooltip} side="top" sideOffset={6}>
            {label}
            <Tooltip.Arrow className={styles.builderTooltipArrow} />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
